import { styled } from 'linaria/lib/react';

import { DATA_WORD_INDEX_ATTR, ELLIPSIS_CLASSNAME } from './constants';

export const StyledThoughtAnimation = styled.div`
  .${ELLIPSIS_CLASSNAME}[${DATA_WORD_INDEX_ATTR}='1'] {
    text-decoration: underline;
  }
`;
